import { useEffect, useState } from "react"
import { Modal, ModalId, O } from "../../../../../features/ui"
import { describeHelpers } from "../../../../../features/data-types"
import { CreditPayment } from "../../../state/types"
import { useCreditPaymentService } from "../../../services/creditPaymentService"
import { useActions } from "./actions"

type Props = {
    creditPayment: CreditPayment
}

export const AnnulCreditPaymentModal = (props: Props) => {
    const { creditPayment } = props

    const [blockReason, setBlockReason] = useState<O<string>>()
    const [loading, setLoading] = useState(true)

    const { describeCode } = describeHelpers

    const { getAnnulBlockReason } = useCreditPaymentService()

    const { submitAnnulCreditPayment } = useActions()

    useEffect(() => {
        setLoading(true)
        getAnnulBlockReason(creditPayment).then(reason => {
            setBlockReason(reason)
            setLoading(false)
        })
    }, [creditPayment.id])

    const renderBody = () => blockReason ? (
        <p>{blockReason}</p>
    ) : (
        <>
            <p>
                {`Está por anular el Cobro ${describeCode(creditPayment)}. `}
                Se va a revertir todo lo que generó, como si nunca se hubiese hecho:
            </p>
            <ul>
                <li>Las ventas y acopios imputados vuelven a tener la deuda que tenían.</li>
                <li>El crédito a favor del cliente vuelve a su valor anterior.</li>
                <li>El dinero acreditado se descuenta de la caja y se eliminan sus movimientos.</li>
                <li>Si el pago fue con cheque, el cheque se elimina.</li>
            </ul>
            <p>El cobro se va a eliminar. Esta acción es irreversible.</p>
        </>
    )

    const onSubmit = () => submitAnnulCreditPayment(creditPayment.id)

    return (
        <Modal
            modalId={ModalId.ANNUL_CREDIT_PAYMENT}
            title="Anular Cobro?"
            submitLabel="Anular"
            submitKind="secondary"
            widthSize="m"
            disableSubmit={loading || !!blockReason}
            onSubmit={onSubmit}
        >
            {renderBody()}
        </Modal>
    )
}
